<h4>
  {{ title }}
</h4>

<ng-container *ngIf="canBookARepair; else NotValidToBookARepair">
  <section class="initial-questions">
    <ng-container
      *ngIf="currentClaimTypes.length === 1 && onlyBreakDownOption && !isASV"
    >
      <p>
        You're covered for breakdowns. For more details, please
        <a href="#" (click)="$event.preventDefault(); downloadPlanDocs()"
          >read your policy documents.</a
        >
      </p>
    </ng-container>
    <ng-container *ngIf="isASV">
      <p>Your plan includes one service per year.</p>
    </ng-container>

    <ng-container *ngIf="viewModel.canShowClaimSelection">
      <ng-container *ngIf="currentClaimTypes.length > 1">
        <p>
          Your {{ mmrItem.code_description | lowercase }} is protected against
          {{ !inWarranty ? 'breakdowns and' : '' }} accidental damage.
        </p>
        <p *ngIf="inWarranty">
          You also have breakdown cover under the
          {{ mmrItem.manufacturer }} guarantee.
        </p>

        <section
          class="claim-types"
          [class.claim-type-selected]="selectedOption"
        >
          <button
            *ngFor="let claimType of currentClaimTypes"
            (click)="onClaimTypeSelected(claimType)"
            [class.selected]="selectedOption?.value === claimType.claimTypeCode"
            [attr.data-testid]="'claim-type-' + claimType.claimTypeCode"
          >
            <img [src]="claimType.image" alt="" />
            <img [src]="claimType.activeImage" alt="" class="active" />
            {{ claimType.text }}
          </button>
        </section>
      </ng-container>

      <ng-container *ngIf="currentClaimTypes.length === 1 && !pastFirstStage">
        <p *ngIf="currentClaimTypes[0].claimTypeCode === 'AD'">
          You have no repair booked.
        </p>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="viewModel.canShowManufacturerQuestion">
      <section class="manufacturer-question">
        <p class="manufacturer-question__title">
          Let us know who made your appliance
        </p>
        <p class="manufacturer-question__subtitle">
          This helps us select the right service provider for your repair.
        </p>
        <section class="manufacturer-search">
          <app-text-search
            name="manufacturer"
            [label]="'Search brands'"
            [placeHolder]="'Start typing here...'"
            [iconPosition]="'start'"
            [options]="manufacturerState.searchOptions"
            [ngModel]="manufacturerState.selectedManufacturer"
            [showSelectedFault]="true"
            [selectedLabel]="'Selected brand'"
            [showSelectedValue]="true"
            [selectedValue]="manufacturerState.selectedManufacturer"
            [showRemoveIcon]="true"
            (textChanged)="handleManufacturerSearch($event)"
            (ngModelChange)="handleManufacturerChange($event)"
          ></app-text-search>
        </section>
      </section>
    </ng-container>

    <ng-container
      *ngIf="
        viewModel.canShowProductTypeQuestion &&
        !(selectedOption?.value === 'BD' && inWarranty)
      "
    >
      <claims-repair-product-type-question
        [claimType]="claimType"
        [claim]="claim"
        [gasSafetyAnswers]="gasSafetyAnswers"
        [resetStateToggle]="resetProductTypeQuestionToggle"
        (stateChange)="handleProductTypeStateChange($event)"
        (selectionChange)="handleProductTypeSelectionChange($event)"
      ></claims-repair-product-type-question>
    </ng-container>

    <ng-container #ApplianceCondition>
      <ng-container *ngIf="viewModel.canShowApplianceCondition">
        <ng-container
          *ngTemplateOutlet="ApplianceConditionSelection"
        ></ng-container>
      </ng-container>
    </ng-container>

    <ng-container #BaxiLetter>
      <ng-container *ngIf="viewModel.canShowBaxiQuestion">
        <ng-container *ngTemplateOutlet="BaxiLetterSelection"></ng-container>
      </ng-container>
    </ng-container>

    <section class="actions" *ngIf="viewModel.canShowInitialCta">
      <dgx-components-button
        iconName="arrow-right"
        iconAlign="right"
        (clicked)="startSingleClaimFlow()"
      >
        {{ buttonText }}
      </dgx-components-button>
    </section>

    <ng-container
      *ngIf="
        viewModel.canShowClaimSelection || viewModel.showGasEmergencyContent
      "
    >
      <ng-container
        *ngIf="selectedOption?.value === 'BD' && inWarranty; else AddressBlock"
      >
        <ng-container *ngTemplateOutlet="InWarrantyContent"></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #AddressBlock>
      <ng-container *ngIf="viewModel.canShowAddressConfirmation">
        <ng-container *ngTemplateOutlet="AddressSelection"></ng-container>
      </ng-container>
    </ng-template>
  </section>

  <section *ngIf="viewModel.canShowBookingCta" class="radio-answered">
    <section class="correct-address" [class.has-excess]="isExcess || isCallOut">
      <section *ngIf="isExcess || isCallOut" class="excess-message">
        <dgx-components-icon name="circle-exclamation"> </dgx-components-icon>
        <p>
          You’ll need to pay {{ isCallOut ? 'a call-out' : 'an excess' }} fee
          before completing your booking.
        </p>
      </section>
      <dgx-components-button
        [attr.data-testid]="'book-repair-button'"
        iconName="arrow-right"
        iconAlign="right"
        (clicked)="trackClick(buttonText); bookARepair()"
      >
        {{ currentClaimTypes.length === 1 ? 'Continue' : buttonText }}
      </dgx-components-button>
    </section>
  </section>

  <section
    *ngIf="viewModel.canShowAddressConfirmation && addressCorrect === false"
    class="radio-answered"
  >
    <section class="update-your-address">
      <section class="text">
        <p class="typog-body">
          <dgx-components-icon name="circle-exclamation" [size]="'sm'" />
          Update your address
        </p>
        <p class="typog-body">You can do this in Your Details.</p>
      </section>
      <section class="your-details-link">
        <a
          [href]="config.personalDetailsPage"
          (click)="trackClick('Your details')"
        >
          Your details
        </a>
        <dgx-components-icon name="arrow-right" size="md" />
      </section>
    </section>
  </section>
</ng-container>

<ng-template #ApplianceConditionSelection>
  <p
    class="radio-question"
    [style.font-weight]="viewModel.applianceConditionQuestion.fontWeight"
  >
    {{ viewModel.applianceConditionQuestion.text }}
  </p>

  <section class="radio-confirmation">
    <label
      [attr.data-testid]="
        option ? 'applianceCondition-yes' : 'applianceCondition-no'
      "
      class="radio-options"
      *ngFor="let option of [true, false]"
      [for]="option ? 'applianceCondition-yes' : 'applianceCondition-no'"
    >
      <section class="radio-button"></section>
      <input
        [(ngModel)]="applianceInGoodCondition"
        (ngModelChange)="handleApplianceConditionChange()"
        type="radio"
        [value]="option"
        [id]="option ? 'applianceCondition-yes' : 'applianceCondition-no'"
        [name]="'applianceCondition-' + claimType"
      />
      {{ option ? 'Yes' : 'No' }}
    </label>
  </section>

  <section
    *ngIf="applianceInGoodCondition === false"
    class="boiler-bad-condition-message"
  >
    <section>
      <p>
        If your boiler is not in good working condition please book a repair.
      </p>
    </section>
  </section>
</ng-template>

<ng-template #BaxiLetterSelection>
  <p
    class="radio-question"
    [style.font-weight]="viewModel.applianceConditionQuestion.fontWeight"
  >
    {{ viewModel.baxiLetterQuestion.text }}
  </p>

  <section class="radio-confirmation">
    <label
      [attr.data-testid]="option ? 'baxiLetter-yes' : 'baxiLetter-no'"
      class="radio-options"
      *ngFor="let option of [true, false]"
      [for]="option ? 'baxiLetter-yes' : 'baxiLetter-no'"
    >
      <section class="radio-button"></section>
      <input
        [(ngModel)]="receivedBaxiLetter"
        (ngModelChange)="handleBaxiLetterChange()"
        type="radio"
        [value]="option"
        [id]="option ? 'baxiLetter-yes' : 'baxiLetter-no'"
        [name]="'receivedBaxiLetter-' + claimType"
      />
      {{ option ? 'Yes' : 'No' }}
    </label>
  </section>

  <section
    *ngIf="viewModel.canShowBaxiConfirmedNotice"
    class="baxi-letter-notice"
    data-testid="baxi-letter-confirmed-notice"
  >
    <dgx-components-icon
      name="info-circle"
      size="md"
      class="baxi-letter-notice__icon"
    />
    <div class="baxi-letter-notice__text">
      <p class="baxi-letter-notice__heading">
        If you haven’t heard from Baxi, your booking might not go through
      </p>
      <p>
        Baxi should contact you within 45 days of your renewal date to arrange a
        service.
      </p>
    </div>
  </section>

  <section
    *ngIf="viewModel.canShowBaxiCallPanel"
    class="baxi-letter-info"
    data-testid="baxi-letter-call-panel"
  >
    <p class="baxi-letter-info__heading">If you haven’t heard from Baxi</p>
    <p>
      If your plan is due to renew, Baxi should contact you within 45 days of
      your renewal date to arrange a service. If you don’t hear from them after
      this time, please get in touch with their team. Call Baxi on
    </p>
    <div class="inwarranty__contact__container">
      <dgx-components-icon name="phone" size="md" class="contact-image" />
      <a class="contact-number" [phone]="'0344 335 6556'"> 0344 335 6556 </a>
    </div>
    <p class="hint">
      Calls cost the basic rate per minute plus your phone company’s access
      charge. <br class="mobile-break" />
      From a mobile, they can cost much more. Calls to 0800 numbers are always
      free.
    </p>
  </section>
</ng-template>

<ng-template #AddressSelection>
  <p
    class="radio-question"
    [style.font-weight]="viewModel.addressQuestion.fontWeight"
  >
    {{ viewModel.addressQuestion.text }}
  </p>

  <section class="client-address">
    <p dgxQmSanitise="block">{{ correspondenceAddress?.addressLine1 }}</p>
    <p
      *ngIf="
        correspondenceAddress?.addressLine2 ||
        correspondenceAddress?.addressLine3
      "
      dgxQmSanitise="block"
    >
      {{
        correspondenceAddress?.addressLine2 ??
          correspondenceAddress?.addressLine3
      }}
    </p>
    <p dgxQmSanitise="block">{{ correspondenceAddress?.postalCode }}</p>
  </section>

  <p
    class="base-typography address-warning"
    *ngIf="viewModel.addressWarningText"
  >
    {{ viewModel.addressWarningText }}
  </p>

  <section class="radio-confirmation">
    <label
      [attr.data-testid]="
        option
          ? 'addressCorrect-yes-' + claimType
          : 'addressCorrect-no-' + claimType
      "
      class="radio-options"
      *ngFor="let option of [true, false]"
      [for]="
        option
          ? 'addressCorrect-yes-' + claimType
          : 'addressCorrect-no-' + claimType
      "
    >
      <section class="radio-button"></section>
      <input
        [(ngModel)]="addressCorrect"
        type="radio"
        [value]="option"
        [id]="
          option
            ? 'addressCorrect-yes-' + claimType
            : 'addressCorrect-no-' + claimType
        "
        [name]="'addressCorrect-' + claimType"
      />
      {{ option ? 'Yes, it is' : "No, it isn't" }}
    </label>
  </section>
</ng-template>

<ng-template #NotValidToBookARepair>
  <section class="initial-questions">
    <ng-container
      *ngTemplateOutlet="
        planStillINWaitPeriodButOutOfWarranty ||
        planStillInWarrantyAndWaitPeriod
          ? WaitPeriod
          : InWarrantyContent
      "
    ></ng-container>
  </section>
</ng-template>

<ng-template #InWarrantyContent>
  <ng-container *ngIf="validWarrantyNumber">
    <p class="base-typography">
      To book your {{ claimType | lowercase }} under the
      {{ mmrItem?.manufacturer }} guarantee, please call:
    </p>
    <div class="inwarranty__contact__container">
      <dgx-components-icon name="phone" size="md" class="contact-image" />
      <a class="contact-number" [phone]="warrantyContactNumber">
        {{ warrantyContactNumber }}
      </a>
    </div>
    <p class="hint">
      Calls cost the basic rate per minute plus your phone company’s access
      charge. <br class="mobile-break" />
      From a mobile, they can cost much more. Calls to 0800 numbers are always
      free.
    </p>
  </ng-container>
  <ng-container *ngIf="!validWarrantyNumber">
    <p class="base-typography">
      Your appliance is still covered under the
      {{ mmrItem?.manufacturer }} guarantee. To {{ buttonText | lowercase }},
      please get in touch with {{ mmrItem?.manufacturer }} directly.
    </p>
  </ng-container>
</ng-template>

<ng-template #WaitPeriod>
  <div>
    <div class="notice-box">
      <p>
        As you haven’t reached your plan’s start date, you can’t book
        {{ waitPeriodAction }} just yet.
      </p>

      <p>
        You can find the start date on your
        <a href="#" (click)="$event.preventDefault(); downloadPlanDocs()"
          >plan documents</a
        >.
      </p>
    </div>
  </div>
</ng-template>
